import * as React from 'react';

export const RailwayIcon = () => (
  // oxlint-disable-next-line react/forbid-elements
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fill="none" fillRule="nonzero">
      <path fill="#FFF" fillOpacity=".01" d="M0 0h16v16H0z" />
      <path
        fill="#757575"
        fillOpacity=".54"
        d="M11.429 12.571L12.57 16H11.43l-1.143-3.429H5.714L4.571 16H3.43l1.142-3.429H3.55a1.143 1.143 0 0 1-1.138-1.256l.915-9.143c.058-.584.55-1.03 1.137-1.03H6.02a2.285 2.285 0 0 1 3.96 0h1.557c.587 0 1.079.446 1.137 1.03l.915 9.143a1.143 1.143 0 0 1-1.138 1.256H11.43zM4.57 2.286v4.571h6.858V2.286H4.57zm0 6.857v1.143h1.143V9.143H4.571zm5.715 0v1.143h1.143V9.143h-1.143z"
      />
    </g>
  </svg>
);
